module.exports = __webpack_public_path__ + "img/Banner_Delphinus.a69fd4df.png";